<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Log details'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <pre>{{log.parameters|json}}</pre>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Close'|translate}}
        </button>

    </div>
</div>
